import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { IncreaseBalanceApprovalService } from 'services';

import { Button } from 'components/ui/form';
import { File } from 'components/ui/formik';
import styles from './file-form.module.scss';

const FileForm = ({ contractId, addFile }) => {
  const submit = async (values) => {
    const formData = new FormData();
    formData.append('contractId', contractId);
    formData.append('file', values.file);
    const file = await new IncreaseBalanceApprovalService().sendApproval(formData);
    if (file.toast !== 'error') {
      addFile(file);
    }
  };

  return (
    <Formik
      enableReinitialize
      onSubmit={submit}
      initialValues={{ file: null }}
      validationSchema={
        Yup.object().shape({
          file: Yup.mixed().required(),
        })}
    >
      {({ values, handleSubmit, setFieldValue }) => (
        <>
          <form onSubmit={handleSubmit} className={styles.form}>
            <File
              enableReinitialize
              accept=".jpg, .jpeg, .png, .xlsx, .xls, .pdf"
              name="file"
              onChange={(event) => {
                setFieldValue('file', event.currentTarget.files[0]);
              }}
              label={(
                <>
                  <p>
                    Прикрепить файл
                  </p>
                  <span> оплаты</span>
                </>
            )}
            />
            {values.file && (
            <Button className={styles.button} type="submit">Отправить файл</Button>)}
          </form>
        </>
      )}
    </Formik>
  );
};

export default FileForm;
